export const removeLineStampHandler = (index, lineTimestamps, setLineTimestamps, updateAudioTime, setCurrentLine) => {
    const previousLineTimestamp = lineTimestamps;
    delete previousLineTimestamp[index];
    const lastLine = Object.keys(previousLineTimestamp)[Object.keys(previousLineTimestamp).length - 1];
    if (previousLineTimestamp[lastLine]?.end) {
        delete previousLineTimestamp[lastLine].end;
    }

    setLineTimestamps({
        ...previousLineTimestamp,
    });

    updateAudioTime(lastLine ? lineTimestamps[lastLine]?.start : 0);

    setCurrentLine(lastLine ? parseInt(lastLine) : null);
}

export const getTheNextLineThatIsNotEmpty = (index, lineTimestamps, lines) => {
    // Return null if index is null or invalid
    if (index === null || index === undefined || isNaN(index)) {
        return null;
    }

    // Check if index is within bounds
    if (index < 0 || index >= lines.length) {
        return null;
    }

    // check if there is a end time for the current line if not return the current line
    if (lineTimestamps[index]?.end) {
        return index;
    }

    for (let i = index; i < lines.length; i++) {
        // Check if lines[i] exists and is a string before calling trim
        if (lines[i] && typeof lines[i] === 'string' && lines[i].trim().length > 0) {
            return i;
        }
    }

    return null;
}
// handle keys
export const handleSpaceBar = (e, finishedSyncing, syncNextLine, editingLine) => {

    if (e.code === 'Space') {
        if (finishedSyncing || editingLine) {
            return;
        }
        e.preventDefault();
        syncNextLine();
    }
};